import React from "react";
interface Props {
    percent: number
}

const ProgressBar = ({percent}: Props) => {

    return (
        <div className="progress">
            <div className="bar" style={{width:`${percent}%`}}>
            </div>
        </div>
    )
}

export default ProgressBar;